var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoFileAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "87px",
    viewBox: "0 0 77 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Lock_Fil_Large Video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Lock_Fil_Large-Video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lock-File",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Video-Camera_3952762",
    transform: "translate(0.500000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2769128,5.75073201 C74.8268796,5.48024768 74.2605456,5.43555897 73.7700599,5.64018624 L54.7776447,13.5359766 L54.7776447,4.41007056 C54.7776447,1.98041569 52.6538922,0 50.0371257,0 L4.74051896,0 C2.12628077,0 0,1.98041569 0,4.41007056 L0,44.5899294 C0,47.0219364 2.12628077,49 4.74051896,49 L50.039654,49 C52.6564205,49 54.780173,47.0219364 54.780173,44.5899294 L54.780173,35.4640234 L73.7725882,43.3598138 C73.9799069,43.4444871 74.2023952,43.4868238 74.419827,43.4868238 C74.7206919,43.4868238 75.0215569,43.4068545 75.2794411,43.249268 C75.7294744,42.9787837 76,42.5130802 76,42.0168003 L76,6.98319973 C75.9974717,6.48456775 75.7269461,6.02121634 75.2769128,5.75073201 Z M51.619827,44.5922815 C51.619827,45.4037345 50.9144378,46.062305 50.039654,46.062305 L4.74051896,46.062305 C3.86826347,46.062305 3.16034597,45.4037345 3.16034597,44.5922815 L3.16034597,4.41007056 C3.16034597,3.59861758 3.86826347,2.94004704 4.74051896,2.94004704 L50.039654,2.94004704 C50.9144378,2.94004704 51.619827,3.59861758 51.619827,4.41007056 L51.619827,44.5922815 Z M72.8371257,39.751788 L54.7776447,32.2464359 L54.7776447,16.7582681 L72.8371257,9.25056401 L72.8371257,39.751788 Z",
    id: "Shape",
    fill: "#0082FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3590417,8 L31.6409583,8 C30.7325238,8 30,8.448 30,9 C30,9.5536 30.7325238,10 31.6409583,10 L44.3590417,10 C45.2622251,10 46,9.5536 46,9 C46,8.448 45.2622251,8 44.3590417,8 Z",
    id: "Path",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.119827,61.5922815 C52.119827,62.4037345 51.4144378,63.062305 50.539654,63.062305 L5.24051896,63.062305 C4.36826347,63.062305 3.66034597,62.4037345 3.66034597,61.5922815 L3.66034597,21.4100706 C3.66034597,20.5986176 4.36826347,19.940047 5.24051896,19.940047 L50.539654,19.940047 C51.4144378,19.940047 52.119827,20.5986176 52.119827,21.4100706 L52.119827,61.5922815 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "73.3371257 56.751788 55.2776447 49.2464359 55.2776447 33.7582681 73.3371257 26.250564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.397828,54.5 L35.3251974,54.5 L30.9519791,41.5875615 L32.2471642,41.0495274 C35.4341474,39.7256194 37.5,36.8425904 37.5,33.6436108 C37.5,29.1758377 33.497728,25.5 28.5000414,25.5 C23.5022832,25.5 19.5,29.1758279 19.5,33.6436108 C19.5,36.7628431 21.463503,39.585166 24.5293475,40.9529062 L25.7753718,41.5087848 L21.397828,54.5 Z",
    id: "Fill-5",
    stroke: "#0082FF",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0082FF",
    fillRule: "nonzero",
    opacity: 0.140601749,
    points: "52.6956522 61 3 61 3 66.1538462 52.6956522 66.1538462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0082FF",
    fillRule: "nonzero",
    opacity: 0.140601749,
    points: "54.3554435 46.2638432 54.4964474 51.5697351 74.6956522 59.1538462 74.6956522 54"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFileAttachment);
export default __webpack_public_path__ + "static/media/video-file-attachment.568d3278bdadf79ccba5d97263a577ba.svg";
export { ForwardRef as ReactComponent };